/**
* A utility that converts the LocPlatform's translation file to
* one that makes it easier to look up by languages.
*
* Initial Format from LocPlatform:
*  {
*    "results": 2,
*    "translations": [{
*      "en": "Some String",
*      "comment": "Some Description",
*      "key": "some_key"
*    }, {
*      "en": "Some other String",
*      "comment": "Other Description",
*      "key": "some_other_key"
*    }]
*  }
*
* Separate Langs Format:
*  {
*    "en": {
*      "some_key": {
*        "value": "Some String"
*        "comment": "Some Description",
*      },
*     "some_other_key": {
*       value": "Some other String"
*       "comment": "Other Description",
*      },
*    }
*  }
*/

/**
 * ex translationSet: {
 *   "en": "Some String",
 *   "fr": "Some String in French",
 *   "comment": "Some Description",
 *   "key": "some_key"
 * ex available countries array: ["en", "fr"]
 */
/**
 * Takes in the first set of translations and makes an array of
 * countries available
 * @param  {object} translationSet First subset of translation object from json
 * @return {array}                 Returns avaliable countries
 */
export const getAvailableCountriesFromTranslation = (translationSet) => {
  const notSupportedLanguages = ['key', 'comment'];
  return Object.keys(translationSet)
    .filter(key => !notSupportedLanguages.includes(key));
};

/**
 * Translate loctool json to country based json format to better support production
 * @param {object} translations - The JSON translation file from the LocPlatform
 * @param {bool} lazy - Wheter to check available countries for each string or check for just first string.
 * @return {object} newTranslations - JSON file separated by countries
 */
export const convertTranslationsFromLocPlatform = (translations, lazy = true) => {
  const newTranslations = {};
  let countryKeys = getAvailableCountriesFromTranslation(translations.translations[0]);
  if (!lazy) {
    translations.translations.forEach((locStringData) => {
      const newKeys = getAvailableCountriesFromTranslation(locStringData);
      countryKeys = [
        ...countryKeys,
        ...newKeys,
      ];
    });
  }
  countryKeys.forEach((countryKey) => {
    newTranslations[countryKey] = {};
    translations.translations.forEach((locStringData) => {
      newTranslations[countryKey][locStringData.key] = {
        value: locStringData[countryKey],
        comment: locStringData.comment,
      };
    });
  });
  return newTranslations;
};
